import { render, staticRenderFns } from "./ClearFileSelection.vue?vue&type=template&id=4053b3c9"
import script from "./ClearFileSelection.vue?vue&type=script&lang=js"
export * from "./ClearFileSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports